import EncryptionEngine from "./EncryptionEngine";
import ExtensionPipeline from "./ExtensionPipeline";
import VaultDataFlow from "./VaultDataFlow";
import SecurityModel from "./SecurityModel";
import ImportEngine from "./ImportEngine";

export default function SecureVaultArchitecturePanel({ project }) {
  return (
    <div className="space-y-8">
      <VaultDataFlow />
      <EncryptionEngine />
      <ExtensionPipeline />
      <ImportEngine />
      <SecurityModel />
    </div>
  );
}
